module.exports = __webpack_public_path__ + "static/media/story-banner.73a428f8.png";